import React from "react";
import { FaGithub } from "react-icons/fa";
import { CgFileDocument } from "react-icons/cg";

const ProjectBox = ({
  projectPhoto,
  projectName,
  description,
  github,
  link,
}) => {
  return (
    <div className="projectBox">
      <div className="projectImageWrapper">
        <img
          className="projectPhoto"
          src={projectPhoto}
          alt={`${projectName} preview`}
        />
        <div className="projectOverlay"></div>
      </div>
      <div className="projectBody">
        <div className="projectInfo">
          <h3 className="projectTitle">{projectName}</h3>
          <p className="projectDescription">{description}</p>
        </div>
        <div className="projectActions">
          {github !== "#" && (
            <a href={github} target="_blank" rel="noreferrer" className="projectLink">
              <button className="projectbtn projectbtn-secondary">
                <FaGithub />
                <span>GitHub</span>
              </button>
            </a>
          )}
          {link !== "#" && (
            <a href={link} target="_blank" rel="noreferrer" className="projectLink">
              <button className="projectbtn projectbtn-primary">
                <CgFileDocument />
                <span>Live Demo</span>
              </button>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectBox;
